import { render } from "./TrashIcon.vue?vue&type=template&id=6d753ccf"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/TrashIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d753ccf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d753ccf', __exports__)) {
    api.reload('6d753ccf', __exports__)
  }
  
  module.hot.accept("./TrashIcon.vue?vue&type=template&id=6d753ccf", () => {
    api.rerender('6d753ccf', render)
  })

}


export default __exports__